import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {
  JobSourcingActionTypes,
  JobSourcingFail,
  LoadJobSourcing,
  LoadJobSourcingSuccess,
  PostFinnBoard,
  PostFinnBoardSuccess,
  PurchaseJobSourcingBoard,
  PurchaseJobSourcingBoardSuccess,
  SelectFinnBoard,
  SelectFinnBoardSuccess,
  UpdateJobSourcing,
  UpdateJobSourcingSuccess,
} from '../actions/job-sourcing.actions';
import { Action, Store } from '@ngrx/store';
import { JobSourcing } from '../models/job-sourcing';
import { JobSourcingService } from '../services/job-sourcing.services';
import { FinnAdvertisement } from '../../lib/classes/finn/finnAdvertisement';
import * as fromJobs from '../../jobs-module/reducers';

@Injectable()
export class JobSourcingEffects {
  @Effect()
  loadJobSourcing$: Observable<Action> = this.actions$.pipe(
    ofType<LoadJobSourcing>(JobSourcingActionTypes.LoadJobSourcing),
    switchMap(action =>
      this.jobSourcingService.getJobSourcing(action.payload.jobId).pipe(
        map((response: JobSourcing) => {
          return new LoadJobSourcingSuccess({
            jobSourcing: response,
          });
        }),
        catchError(errors => {
          console.error('fail?', errors);
          return of(new JobSourcingFail({ errors }));
        })
      )
    )
  );

  @Effect()
  purchaseJobSourcing$: Observable<Action> = this.actions$.pipe(
    ofType<PurchaseJobSourcingBoard>(
      JobSourcingActionTypes.PurchaseJobSourcingBoard
    ),
    mergeMap(action =>
      this.jobSourcingService.purchaseJobSourcing(action.payload.jobId).pipe(
        map((response: JobSourcing) => {
          return new PurchaseJobSourcingBoardSuccess({
            jobSourcing: response,
          });
        }),
        catchError(errors => {
          console.error('fail?', errors);
          return of(new JobSourcingFail({ errors }));
        })
      )
    )
  );

  @Effect()
  postFinnJobBoard$: Observable<Action> = this.actions$.pipe(
    ofType<PostFinnBoard>(JobSourcingActionTypes.PostFinnBoard),
    switchMap(action =>
      this.jobSourcingService
        .postFinnJobBoard(action.payload.jobId, action.payload.boardId)
        .pipe(
          map((response: JobSourcing) => {
            return new PostFinnBoardSuccess({
              jobSourcing: response,
            });
          }),
          catchError(errors => {
            console.error('fail?', errors);
            return of(new JobSourcingFail({ errors }));
          })
        )
    )
  );

  @Effect()
  recreateFinnJobBoard$: Observable<Action> = this.actions$.pipe(
    ofType<SelectFinnBoard>(JobSourcingActionTypes.SelectFinnBoard),
    switchMap(action => {
      if (action.payload.board.finn_ad) {
        return of(
          new SelectFinnBoardSuccess({
            finnAdvertisement: action.payload.board.finn_ad,
          })
        );
      } else {
        return this.jobSourcingService
          .recreateFinnJobBoard(action.payload.board.id)
          .pipe(
            map((response: FinnAdvertisement) => {
              return new SelectFinnBoardSuccess({
                finnAdvertisement: response,
              });
            }),
            catchError(errors => {
              console.error('fail?', errors);
              return of(new JobSourcingFail({ errors }));
            })
          );
      }
    })
  );

  @Effect()
  updateJobSourcing$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateJobSourcing>(JobSourcingActionTypes.UpdateJobSourcing),
    switchMap(action =>
      this.jobSourcingService
        .updateJobSourcing(action.payload.jobSourcing)
        .pipe(
          map((response: JobSourcing) => {
            return new UpdateJobSourcingSuccess({
              jobSourcing: response,
              error: null,
              isUpdateSuccess: true,
            });
          }),
          catchError(httpError => {
            return of(
              new UpdateJobSourcingSuccess({
                jobSourcing: action.payload.jobSourcing,
                error:
                  Object.keys(httpError.error)[0] +
                  ': ' +
                  httpError.error[Object.keys(httpError.error)[0]],
                isUpdateSuccess: false,
              })
            );
          })
        )
    )
  );

  constructor(
    private actions$: Actions,
    private jobSourcingService: JobSourcingService,
    private jobsStore: Store<fromJobs.State>
  ) {}
}
